import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { ActivitiesStatus } from 'src/assets/data/enum/fieldActivities.enum';

@Pipe({
  name: 'myfilter',
  pure: true,
  standalone: false,
})
export class MyfilterPipe implements PipeTransform {
  constructor() {}

  transform(
    items: any[],
    field: any,
    objfield: any,
    value: any,
    EqualOrDifferent: string,
    selectedYear: number = null
  ): any[] {
    const items2: any[] = items;
    let itemsIsntNull: any[] = [];
    let currentdate: Date = null;
    items = [];

    if (!items2) {
      return [];
    }

    if (!value || value.length === 0) {
      return items2;
    }

    if (EqualOrDifferent === 'equal') {
      if (objfield) {
        itemsIsntNull = items2.filter((it) => it[field] !== null && it[field] !== undefined);

        return itemsIsntNull.filter((it) => String(it[field][objfield]) === String(value));
      } else {
        if (items2) {
          if (items2.length > 0) {
            return items2.filter((it) => String(it[field]) === String(value));
          } else {
            if (String(items2[field]) === String(value)) {
              return items2;
            } else {
              return [];
            }
          }
        } else {
          return null;
        }
      }
    } else if (EqualOrDifferent === 'clear') {
      if (objfield) {
        itemsIsntNull = items2.filter((it) => it[field] !== null && it[field] !== undefined);
        return itemsIsntNull.filter((it) => it[field][objfield] !== undefined);
      } else {
        return (itemsIsntNull = items2.filter(
          (it) => it[field] !== null && it[field] !== undefined
        ));
      }
    } else if (EqualOrDifferent === 'different') {
      if (objfield) {
        itemsIsntNull = items2.filter((it) => it[field] !== null && it[field] !== undefined);

        return itemsIsntNull.filter((it) => String(it[field][objfield]) !== String(value));
      } else {
        return items2.filter((it) => String(it[field]) !== String(value));
      }
    } else if (EqualOrDifferent === 'arraycontain') {
      itemsIsntNull = items2.filter((it) => it[field] !== null && it[field] !== undefined);

      if (objfield) {
        return itemsIsntNull.filter((it) => it[field][objfield].includes(Number(value)));
      } else {
        return itemsIsntNull.filter((it) => it[field].includes(Number(value)));
      }
    } else if (EqualOrDifferent === 'arraycontainstring') {
      itemsIsntNull = items2.filter((it) => it[field] !== null && it[field] !== undefined);

      if (objfield) {
        return itemsIsntNull.filter((it) => it[field][objfield].includes(value));
      } else {
        return itemsIsntNull.filter((it) => it[field].includes(value));
      }
    } else if (EqualOrDifferent === 'arrayContainsArray') {
      itemsIsntNull = items2.filter((it) => it[field] !== null && it[field] !== undefined);

      return itemsIsntNull.filter((it) => it[field].some((item) => value.includes(item)));
    } else if (EqualOrDifferent === 'existInArray') {
      itemsIsntNull = items2.filter((it) => it[field] !== null && it[field] !== undefined);
      // tslint:disable-next-line:prefer-const
      let tmpArray = [];
      if (objfield) {
        value.forEach((element) => {
          // tslint:disable-next-line:prefer-const
          const checkElements = itemsIsntNull.filter(
            (it) => String(it[field][objfield]) === String(element)
          );
          if (checkElements && checkElements.length > 0) {
            tmpArray = [...new Set([...tmpArray, ...checkElements])];
          }
        });
      } else {
        value.forEach((element) => {
          // tslint:disable-next-line:prefer-const
          const checkElements = itemsIsntNull.filter((it) => String(it[field]) === String(element));
          if (checkElements && checkElements.length > 0) {
            tmpArray.concat(checkElements);
          }
        });
      }
      return tmpArray;
    } else if (EqualOrDifferent === 'existInArrayWithUnion') {
      itemsIsntNull = items2.filter((it) => it[field] !== undefined);
      // tslint:disable-next-line:prefer-const
      let tmpArray = [];
      if (objfield) {
        value.forEach((element) => {
          // tslint:disable-next-line:prefer-const
          const checkElements = itemsIsntNull.filter(
            (it) => String(it[field][objfield]) === String(element)
          );
          if (checkElements && checkElements.length > 0) {
            tmpArray = [...new Set([...checkElements, ...tmpArray])];
          }
        });
      } else {
        value.forEach((element) => {
          // tslint:disable-next-line:prefer-const
          const checkElements = itemsIsntNull.filter((it) => String(it[field]) === String(element));
          if (checkElements && checkElements.length > 0) {
            tmpArray = [...new Set([...checkElements, ...tmpArray])];
          }
        });
      }
      return tmpArray;
    } else if (EqualOrDifferent === 'notExistInArray') {
      itemsIsntNull = items2.filter((it) => it[field] !== null && it[field] !== undefined);

      if (objfield) {
        return itemsIsntNull.filter((it) => !value.includes(it[field][objfield]));
      } else {
        return itemsIsntNull.filter((it) => !value.includes(it[field]));
      }
    } else if (EqualOrDifferent === 'greater') {
      currentdate = new Date(value);
      return items2.filter((it) => new Date(it[field]) >= currentdate);
    } else if (EqualOrDifferent === 'lower') {
      currentdate = new Date(value);
      return items2.filter((it) => new Date(it[field]) < currentdate);
    } else if (EqualOrDifferent === 'isnull') {
      return items2.filter((it) => !it[field]);
    } else if (EqualOrDifferent === 'equalyear') {
      return items2.filter((it) => String(new Date(it[field]).getFullYear()) === String(value));
    } else if (EqualOrDifferent === 'equaldate') {
      return items2.filter(
        (it) => moment(it[field]).format('YYYY-MM-DD') === moment(value).format('YYYY-MM-DD')
      );
    } else if (EqualOrDifferent === 'equalCommodity') {
      if (objfield) {
        itemsIsntNull = items2.filter((it) => it[field] !== null && it[field] !== undefined);

        const valideitemsIsntNull = itemsIsntNull.filter((it) => it['crops'].length > 0);

        return valideitemsIsntNull.filter((it) => {
          const arrtest = [];
          for (let i = 0; i < it[field].length; i++) {
            if (
              it[field][i]['commodity'][objfield] === value &&
              selectedYear === it[field][i]['year']
            ) {
              //String(it[field][i]['commodity'][objfield]).indexOf(String(value)) !== -1
              // return true;
              arrtest.push(it);
            }
          }
          if (arrtest.length > 0) {
            return true;
          } else {
            return false;
          }
        });
      } else {
        if (value === 'nocommodity') {
          itemsIsntNull = items2.filter((it) => it['crops'].length === 0);
          return itemsIsntNull;
        } else {
          return items2.filter((it) => String(it[field]) === String(value));
        }
      }
    } else if (EqualOrDifferent === 'equalSupplyChain') {
      if (objfield) {
        itemsIsntNull = items2.filter((it) => it[field] !== null && it[field] !== undefined);

        const valideitemsIsntNull = itemsIsntNull.filter((it) => it['crops'].length > 0);

        return valideitemsIsntNull.filter((it) => {
          const arrtest = [];
          for (let i = 0; i < it[field].length; i++) {
            if (it[field][i] && Array.isArray(it[field][i]['supplyChainDestinations'])) {
              it[field][i]['supplyChainDestinations'].forEach((destination) => {
                if (destination.id === value.id && selectedYear === it[field][i]['year']) {
                  arrtest.push(it);
                }
              });
            }
          }
          if (arrtest.length > 0) {
            return true;
          } else {
            return false;
          }
        });
      }
    } else if (EqualOrDifferent === 'statusFilter') {
      // Filter activities by status [done, todo, expired].
      if (objfield) {
        const currentDate = moment().startOf('day').subtract(1, 'day').valueOf();

        if (!objfield || objfield.length === 0) {
          return items2;
        }

        // Determine which statuses are active.
        const showDone = objfield.some((filter) => filter.key === ActivitiesStatus.DONE);
        const showTodo = objfield.some((filter) => filter.key === ActivitiesStatus.TODO);
        const showExpired = objfield.some((filter) => filter.key === ActivitiesStatus.EXPIRED);

        //Apply filters to activities
        return items2.filter((activity) => {
          const activityDate = moment(activity.activityDate).valueOf();

          if (showDone) {
            if (activity.done || (activity.done === '' && activityDate >= currentDate)) {
              return true;
            }
          }

          if (showTodo) {
            if (!activity.done && activityDate >= currentDate) {
              return true;
            }
          }

          if (showExpired) {
            if (!activity.done && activityDate < currentDate) {
              return true;
            }
          }

          return false;
        });
      }
    }
    // Missing return solved (eslint error)
    return items2;
  }
}
